import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { isBrowser, isMobile } from 'react-device-detect';
import CardSedes from './CardSedes';
import CardEsp from './CardEsp';
import FormClient from './Form';
import CardGeneralData from './CardGeneralData';
import CardOpinion from './CardOpinion';
import CardValoration from './CardValoration';
import CardResponseTime from './CardResponseTime';
import CardLawyerAnswers from './CardLawyerAnswers';
import CardEducation from './CardEducation';
import CardCertification from './CardCertification';
import CardAward from './CardAward';
import CardPublication from './CardPublication';
import CardLaboral from './CardLaboral';
import CardExperience from './CardExperience';
import CardPremiumMainHolder from './CardPremiumMainHolder';
import CardSocialNetworks from './CardSocialNetworks';
import CardLawyers from './CardLawyers';
import CardColaborators from './CardColaborators';
import CardVideos from './CardVideos';
import CardPhotos from './CardPhotos';
import CardCost from './CardCost';
import MainTitle from '../MainTitle';
import ButtonBase from '../Buttons/ButtonBase';
import { connect } from 'react-redux';
import Picture from '../../pages/Profile/Picture';
import './ViewLawyer.scss';
import CardSchedule from './CardSchedule';
import CardCourses from './CardCourses';
import ScrollToTop from '../../components/ScrollToTop';

import firebase, {
  firestore,
} from '../../configs/environments/firebase/firebaseApp';

const preview = '/img/icons/preview.svg';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    margin: '0 40px',
    paddingBottom: 104,
    '@media (max-width: 1359px)': {
      margin: 0,
    },
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: 'center',
    color: theme.palette.text.secondary,
  },
  previewButton: {
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'flex-end',
    '@media (max-width: 1000px)': {
      width: '100%',
    },
  },
}));

const ViewLawyer = ({ authClient }) => {
  const classes = useStyles();
  const small = useMediaQuery('(max-width:959px)');
  const tabletSize = useMediaQuery('(max-width:768px)');
  const [visibleOpinions, setVisibleOpinions] = useState([]);

  function process_opinion(uid) {
    let wholeData = [];
    console.log('uid', uid);

    firestore
      .collection('opinions')
      .doc(uid)
      .collection('opinion')
      .get()
      .then((querySnapshot) => {
        console.log('querySnapshot', querySnapshot);
        querySnapshot.forEach(function (doc) {
          // doc.data() is never undefined for query doc snapshots
          wholeData.push(doc.data());
        });
        const filteredData = wholeData.filter((elem) => {
          if (!elem.visible) {
            return null;
          }
          return elem;
        });
        setVisibleOpinions(filteredData);
      })
      .catch((error) => {});
  }

  useEffect(() => {
    authClient && authClient.uid && process_opinion(authClient.uid);
  }, []);

  return (
    <>
      <div style={{ maxWidth: 1360, margin: 'auto' }}>
        <section
          className="ViewLawyer"
          style={{
            width: '100%',
            flexGrow: 1,
            minHeight: '100vh',
            backgroundColor: '#f6f8fb',
          }}
        >
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              flexWrap: 'wrap',
              padding: tabletSize ? '24px' : '40px',
            }}
          >
            <div style={{ maxWidth: 640 }}>
              <MainTitle
                title="Pre-visualización del perfil"
                subtitle={
                  authClient && authClient.role === 'lawFirm'
                    ? 'Estás en la pre-visualización del perfil del despacho, esta pantalla refleja toda la información que has ingresado y es una vista previa de cómo aparecerá cuando clientes potenciales te encuentren.'
                    : 'Estás en la pre-visualización de tu perfil, esta pantalla refleja toda la información que has ingresado y es una vista previa de cómo aparecerá cuando clientes potenciales te encuentren.'
                }
              ></MainTitle>
            </div>
            <div className={classes.previewButton}>
              <ButtonBase
                disable={true}
                variant="primary"
                style={{
                  width: 257,
                  marginTop: 30,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-around',
                }}
                direction="/dashboard/perfil"
              >
                <img src={preview} alt="" />
                Finalizar previsualización
              </ButtonBase>
            </div>
          </div>
          <div className={classes.root}>
            <Grid container spacing={small ? 0 : 4}>
              <Grid item xs={12} md={8}>
                <div>
                  <img
                    src={
                      authClient && authClient.imgenPortada
                        ? `/img/profile/cover/${authClient.imgenPortada}.png`
                        : '/img/profile/cover/23.png'
                    }
                    alt="imagen de portada"
                    style={{ width: '100%' }}
                  />
                </div>
                <div>
                  <CardGeneralData generalData={authClient} />
                </div>
                {authClient && authClient.idLawFirm ?
                  <div>
                    <CardPremiumMainHolder
                      authClient={authClient}
                      preview={true}
                    />
                  </div> : null
                }
                
                {authClient && authClient.experience ?
                  <div>
                    <CardExperience
                      authClient={authClient}
                      experience={authClient.experience}
                    />
                  </div> : null
                }

                {authClient.membership &&
                  authClient.membership.type !== 'Free' && (
                    <>
                      {authClient.role === 'lawyer' &&
                      authClient.certificationsLawyer &&
                      authClient.certificationsLawyer.length !== 0 ? (
                        <div>
                          <CardCertification
                            certification={authClient.certificationsLawyer}
                            preview
                          />
                        </div>
                      ) : null}
                      {authClient.role === 'lawyer' &&
                      authClient.awardsLawyer &&
                      authClient.awardsLawyer.length !== 0 ? (
                        <div>
                          <CardAward award={authClient.awardsLawyer} preview />
                        </div>
                      ) : null}
                      {authClient.role === 'lawyer' &&
                      authClient.publicationsLawyer &&
                      authClient.publicationsLawyer.length !== 0 ? (
                        <div>
                          <CardPublication
                            publication={authClient.publicationsLawyer}
                            preview
                          />
                        </div>
                      ) : null}
                      {authClient.role === 'lawyer' &&
                      authClient.laboralsLawyer &&
                      authClient.laboralsLawyer.length !== 0 ? (
                        <div>
                          <CardLaboral
                            laboral={authClient.laboralsLawyer}
                            preview
                          />
                        </div>
                      ) : null}
                    </>
                  )}

                <div>
                  <CardEsp specialties={authClient.specialties} />
                </div>

                <div>
                  <CardSocialNetworks
                    socialNetworks={authClient.socialNetworks}
                  />
                </div>

                {authClient.membership &&
                  authClient.membership.type !== 'Free' && (
                    <>
                      {authClient.role === 'lawFirm' &&
                      authClient.holders &&
                      authClient.holders.length &&
                      authClient.holders.length !== 0 ? (
                        <div>
                          <CardLawyers holders={authClient.holders} />
                        </div>
                      ) : null}
                      {authClient.role === 'lawFirm' && (
                        <div>
                          <CardColaborators lawyers={authClient.lawyers} />
                        </div>
                      )}

                      {authClient.role === 'lawyer' &&
                      authClient.educationLawyer &&
                      authClient.educationLawyer.length !== 0 ? (
                        <div>
                          <CardEducation
                            education={authClient.educationLawyer}
                            preview
                          />
                        </div>
                      ) : null}

                      {authClient.role === 'lawyer' &&
                      authClient.coursesLawyer &&
                      authClient.coursesLawyer.length !== 0 ? (
                        <div>
                          <CardCourses
                            courses={authClient.coursesLawyer}
                            preview
                          />
                        </div>
                      ) : null}
                      {(isMobile && authClient.role === 'lawyer') ||
                        authClient.role === 'lawFirm' ?
                        <CardSedes authClient={authClient} /> : null
                      }
                      <div>
                        <CardCost authClient={authClient} />
                      </div>
                      <div>
                        <CardPhotos authClient={authClient} />
                      </div>
                      <div style={{ marginBottom: small ? 0 : 0 }}>
                        <CardVideos authClient={authClient} />
                      </div>
                      <div>
                        <CardOpinion authClient={authClient} />
                      </div>
                    </>
                  )}
              </Grid>
              
              {isBrowser && (
                <Grid item xs={12} md={4}>
                  <FormClient />
                  <CardValoration
                    authClient={authClient}
                    visibleOpinions={visibleOpinions}
                  />
                  {authClient && authClient.community === true ? (
                    <CardResponseTime authClient={authClient} />
                  ) : null}
                  {authClient && authClient.community === true ? (
                    <CardLawyerAnswers authClient={authClient} />
                  ) : null}
                  {authClient.role === 'lawyer' && !isMobile ?
                    <CardSedes authClient={authClient} /> : null
                  }
                  <CardSchedule />
                </Grid>
              )}
            </Grid>
          </div>
        </section>
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  authClient: state.authClient,
});

export default connect(mapStateToProps)(ViewLawyer);
